import React from 'react';

export const HeaderContext = React.createContext({});

export const AppContext = React.createContext({});

export const TestEngineRootContext = React.createContext({});
